import { CREATE_ACTIVITY_SCHEDULE } from "./graphql/createActivitySchedule"
import { DELETE_ACTIVITY_SCHEDULE } from "./graphql/deleteActivitySchedule"
import { UPDATE_ACTIVITY_SCHEDULE } from "./graphql/updateActivitySchedule"
import { CREATE_SHEDULE_PLACE } from "./graphql/createshedulePlace"
import { UPDATE_SCHEDULE_PLACE } from "./graphql/updateShedulePlace"
import { BLOCKING_SCHEDULE_PLACE } from  "./graphql/deleteShedulePlace"
import { graphqlApolloClient } from "../graphql-apollo-client"

export const CalendarizationServices = () => {

  const createActivitySchedule = async (scheduleData, activityId) => {
    const result = await graphqlApolloClient.mutate({
      mutation: CREATE_ACTIVITY_SCHEDULE,
      variables: { scheduleData, activityId }
    })
    return result.data?.CreateActivityScheduleByID
  }

  const createSchedulePlace = async (schedulePlaceData) => {
    const result = await graphqlApolloClient.mutate({
      mutation: CREATE_SHEDULE_PLACE,
      variables: { schedulePlaceData }
    })
    return result.data?.CreateSchedulePlace
  }

  const updateSchedulePlace = async schedulePlaceData => {
    const result = await graphqlApolloClient.mutate({
      mutation: UPDATE_SCHEDULE_PLACE,
      variables: { schedulePlaceData }
    })
    return result.data?.UpdateSchedulePlace
  }

  const blockSchedulePlace = async (id, isBlocking ) => {
    const result = await graphqlApolloClient.mutate({
      mutation: BLOCKING_SCHEDULE_PLACE,
      variables: { schedulePlaceId : [id], isBlocking }
    })
    return result.data?.BlockingSchedulePlace
  }
  
  const updateActivitySchedule = async scheduleData => {
    const result = await graphqlApolloClient.mutate({
      mutation: UPDATE_ACTIVITY_SCHEDULE,
      variables: { scheduleData }
    })
    return result.data?.UpdateActivityScheduleById
  }

  const deleteActivitySchedule = async scheduleIds => {
    const result = await graphqlApolloClient.mutate({
      mutation: DELETE_ACTIVITY_SCHEDULE,
      variables: { scheduleIds }
    })
    return result.data?.DeleteActivityScheduleByID
  }

  return {
    createActivitySchedule,
    updateActivitySchedule,
    deleteActivitySchedule,
    createSchedulePlace,
    updateSchedulePlace,
    blockSchedulePlace
  }
}